import { Components, Theme } from '@mui/material'

// Table (except TablePagination) is not used very much
// Most things are DataGrid, which is a separate component
export const MuiTable: Components<Omit<Theme, 'components'>>['MuiTable'] = {}

export const MuiTableContainer: Components<Omit<Theme, 'components'>>['MuiTableContainer'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderStyle: 'solid',
      borderWidth: theme.strokeWidth.default,
      borderColor: theme.palette.border.strong,

      borderRadius: theme.shape['radius-2xl'],
    }),
  },
}

export const MuiTableHead: Components<Omit<Theme, 'components'>>['MuiTableHead'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.bg.surface.subtle,
    }),
  },
}

export const MuiTableBody: Components<Omit<Theme, 'components'>>['MuiTableBody'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.bg.surface.default,
    }),
  },
}

export const MuiTableFooter: Components<Omit<Theme, 'components'>>['MuiTableFooter'] = {}

export const MuiTableRow: Components<Omit<Theme, 'components'>>['MuiTableRow'] = {}

export const MuiTableCell: Components<Omit<Theme, 'components'>>['MuiTableCell'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(3, 4),
      '--DataGrid-containerBackground': theme.palette.bg.surface.default,

      borderBottomStyle: 'solid',
      borderBottomWidth: theme.strokeWidth.default,
      borderBottomColor: theme.palette.border.strong,
      '.MuiTableRow-root:not(.MuiTableRow-head):last-child &': {
        borderBottomWidth: 0,
      },
    }),
    body: ({ theme }) => ({
      ...theme.typography['body-regular'],
      color: theme.palette.text.default,
    }),
    head: ({ theme }) => ({
      ...theme.typography['body-medium'],
      padding: theme.spacing(1.5, 1.5, 1.5, 4),
      color: theme.palette.text.muted,
      height: 40,

      borderRightStyle: 'solid',
      borderRightWidth: theme.strokeWidth.default,
      borderRightColor: theme.palette.border.strong,
      '&:last-child': {
        borderRightWidth: 0,
      },
    }),
  },
}

export const MuiTablePagination: Components<Omit<Theme, 'components'>>['MuiTablePagination'] = {
  defaultProps: {
    slotProps: {
      actions: {
        previousButton: {
          variant: 'ghost',
          size: 'small',
          color: 'secondary',
        },
        nextButton: {
          variant: 'ghost',
          size: 'small',
          color: 'secondary',
        },
        firstButton: {
          variant: 'ghost',
          size: 'small',
          color: 'secondary',
        },
        lastButton: {
          variant: 'ghost',
          size: 'small',
          color: 'secondary',
        },
      },
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      // Bug in MUI select slot - styles get applied to nested element
      '& .MuiSelect-root': {
        marginRight: `calc(${theme.spacing(1.5)} + ${theme.spacing(2)})`,
        marginLeft: theme.spacing(1.5),
      },
    }),
    selectLabel: ({ theme }) => ({
      ...theme.typography['body-regular'],
      color: theme.palette.text.muted,
    }),
    displayedRows: ({ theme }) => ({
      ...theme.typography['body-regular'],
      color: theme.palette.text.muted,
      // Divider with spacing 2 separated by gap of 1.5
      paddingLeft: `calc(${theme.spacing(1.5)} + ${theme.spacing(2)})`,
      // Divider
      borderLeftWidth: theme.strokeWidth.default,
      borderLeftStyle: 'solid',
      borderLeftColor: theme.palette.border.subtle,
    }),
    actions: ({ theme }) => ({
      marginLeft: theme.spacing(1.5),
    }),
    selectIcon: ({ theme }) => ({
      marginRight: 0,
    }),
  },
}

export const MuiTableSortLabel: Components<Omit<Theme, 'components'>>['MuiTableSortLabel'] = {
  defaultProps: {},
  styleOverrides: {
    root: () => ({
      // TODO
    }),
  },
}
